import { ApiConfig } from "../../Config/ApiConfig";
import {createPostDataAction } from "./CommonAction";
import { NOTIFICATIONLIST , NOTIFICATIONADD } from "../../Constants/NotificationConstants";
export const NotificationlistGetAction = (payload:any) => createPostDataAction(NOTIFICATIONLIST, ApiConfig?.NotificationList,payload,false );
export const NotificationAddAction = (payload:any) => createPostDataAction(NOTIFICATIONADD, ApiConfig?.NotificationAdd,payload,true );
